import React from "react";

function Comprehensive() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Connect to us for your MLM Plan Development
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-2 pr-50 pr-md-15 pr-xs-15">
                <div className="feature-style-one-left-info">
                  {/* <div className="content">
                    <p>
                      An AI solution refers to the application of artificial
                      intelligence technologies to solve specific business or
                      technical problems. These solutions leverage AI techniques
                      always a perfect side.
                    </p>
                  </div> */}
                  <div className="fun-fact-card-one mt-10">
                    <div className="js-counter">218K</div>
                    <h5>AI-Powered Solutions</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-10">
                <div className="feature-style-one-items ">
                  <div className="feature-style-one hover-active-item active">
                    <div className="content">
                      <div className="icon">
                        <img
                          src="https://validthemes.net/site-template/robok/assets/img/icon/9.png"
                          alt="Image Not Found"
                        />
                      </div>
                      <h4>Customized MLM Plans</h4>
                      <p>
                        We offer a range of MLM plans including Binary, Matrix,
                        Unilevel, and more, allowing you to select a structure
                        that aligns with your business strategy and revenue
                        model.
                      </p>
                    </div>
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/9.png"
                      alt="Image Not Found"
                    />
                  </div>

                  <div className="feature-style-one hover-active-item">
                    <div className="content">
                      <div className="icon">
                        <img
                          src="https://validthemes.net/site-template/robok/assets/img/icon/10.png"
                          alt="Image Not Found"
                        />
                      </div>
                      <h4>Scalable, High-Performance Platform</h4>
                      <p>
                        Our solutions are built to scale, supporting high
                        traffic volumes and large user bases while ensuring
                        smooth performance and minimal downtime.
                      </p>
                    </div>
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/9.png"
                      alt="Image Not Found"
                    />
                  </div>

                  <div className="feature-style-one hover-active-item">
                    <div className="content">
                      <div className="icon">
                        <img
                          src="https://validthemes.net/site-template/robok/assets/img/icon/11.png"
                          alt="Image Not Found"
                        />
                      </div>
                      <h4>User-Friendly Interface</h4>
                      <p>
                        A simple, intuitive interface makes it easy for members
                        to join, track their network, and monitor earnings,
                        enhancing user engagement and satisfaction.
                      </p>
                    </div>
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/9.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="feature-style-one hover-active-item">
                    <div className="content">
                      <div className="icon">
                        <img
                          src="https://validthemes.net/site-template/robok/assets/img/icon/11.png"
                          alt="Image Not Found"
                        />
                      </div>
                      <h4>Comprehensive Security</h4>
                      <p>
                        Security is our top priority. Our platforms feature
                        multi-layered security measures, data encryption, and
                        regular audits to protect your users’ information and
                        transaction history.
                      </p>
                    </div>
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/shape/9.png"
                      alt="Image Not Found"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Comprehensive;
